




















import { Component, Prop, Vue } from "vue-property-decorator";
import CellComponent from "./CellComponent.vue";
import { Side, Cell } from "@/models";
import { Direction } from "@/enums";

@Component({
  components: {
    CellComponent
  }
})
export default class SideComponent extends Vue {
  @Prop() private side!: Side;
  move(cell: Cell, direction: Direction) {
    this.$emit("move", cell, direction, this.side);
  }
}
